import React from 'react';

import { Script } from 'gatsby';

interface OrganisationSchema {
  '@context': string;
  '@type': string;
  name: string;
  url: string;
  logo: string;
  sameAs: string[];
  address: {
    '@type': string;
    streetAddress: string;
    addressLocality: string;
    postalCode: string;
    addressCountry: string;
  };
  telephone: string;
  email: string;
}

export const organisationSchema: OrganisationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Policy Expert',
  url: 'https://www.policyexpert.co.uk/',
  logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXx1VgT28j2zmLGhr6pdKMPsV1NkckEyyqzg&s',
  sameAs: [
    'https://www.facebook.com/policyexpert',
    'https://x.com/PolicyExpert',
    'https://www.instagram.com/policyexpert',
    'https://uk.linkedin.com/company/policy-expert',
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '110 Bishopsgate',
    addressLocality: 'City of London',
    postalCode: 'EC2N 4AY',
    addressCountry: 'UK',
  },
  telephone: '0330 060 0600',
  email: 'info@policyexpert.co.uk.',
};

export const OrganisationSchemaScript: React.FC = () => (
  <Script type="application/ld+json">
    {JSON.stringify(organisationSchema, null, 2)}
  </Script>
);
